<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" class="text-muted">
    <div fxLayoutAlign = "row">
        <ng-container *ngIf="featureTags && featureTags['ftags_membership']">
             <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
                <button mat-icon-button
                    [matTooltip]="soldOut ? 'Sold Out' : (product?.product?.type === 'membership' ? 'Purchase Now' : 'Add to Order')"
                    id="carticon" [disabled]="isbuttonMap[product.product.id] || soldOut" *ngIf="!fullBtn" (click)="addToCart(product)">
                    <i class="material-icons addToCartIcon" [ngStyle]="Color ? {'color': Color} : {}"
                        [ngClass]="{'disabledColor': soldOut}" data-icon="add_shopping_cart"></i>
                </button>
            </ng-container>
            <ng-container *ngIf="!!featureTags && !featureTags['ftag_cod_and_other_payment_for_sf']">
                <button mat-icon-button 
            [matTooltip]="soldOut ? 'Sold Out' : (product?.product?.type === 'membership' ? 'Purchase Now' : 'Add to Order')" 
            id="carticon" [disabled]="isbutton || soldOut"
                    *ngIf="!fullBtn" 
                    (click)="addToCart(product)">
                    <i class="material-icons addToCartIcon" [ngStyle]="Color ? {'color': Color} : {}" [ngClass]="{'disabledColor': soldOut}" data-icon="add_shopping_cart"></i>
                </button>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="featureTags && !featureTags['ftags_membership']">
            <button mat-icon-button [matTooltip]="soldOut ? 'Sold Out' : 'Add to order' " id="carticon" [disabled]="isbutton || soldOut"
                *ngIf="!fullBtn" 
                (click)="addToCart(product)">
                <i class="material-icons addToCartIcon" [ngStyle]="Color ? {'color': Color} : {}" [ngClass]="{'disabledColor': soldOut}" data-icon="add_shopping_cart"></i>
            </button>
        </ng-container>
        <button *ngIf="type !== 'dialog' && !fullBtn" mat-icon-button matTooltip="Quick view" id="eyeicon"
            (click)="openProductDialog(product)">
            <i class="material-icons remove_red_eye" data-icon="remove_red_eye"></i>
        </button>
        <ng-container *ngIf="!!fullBtn && fullBtn">
            <div *ngIf="product">
                <ng-container *ngIf="featureTags && featureTags['ftags_membership']">
                    <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
                        <button mat-raised-button id="addToCartFullbtn" [disabled]="isbuttonMap[product.product.id] || soldOut"  class="btn-addtocart" (click)="addToCart(product)" *ngIf="!!product['product']['type'] && product['product']['type'] == 'membership'">
                        Purchase Now
                    </button>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && !featureTags['ftag_cod_and_other_payment_for_sf']">
                    <button mat-raised-button id="addToCartFullbtn"  class="btn-addtocart" (click)="addToCart(product)" *ngIf="!!product['product']['type'] && product['product']['type'] == 'membership'">
                        Purchase Now
                    </button>
                    </ng-container>
                </ng-container>
                <button mat-raised-button id="addToCartFullbtn" [disabled]="soldOut" class="btn-addtocart" *ngIf="!!product['product']['stock_info'] && product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']==0">
                    Sold Out
                </button>
                <ng-container *ngIf="featureTags && featureTags['ftags_membership']">
                    <button mat-raised-button id="addToCartFullbtn" class="btn-addtocart" *ngIf="!!product['product']['stock_info'] && (product['product']['stock_info']['restrict_orders'] == 0 || (product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']!=0)) && product['product']['type'] !== 'membership'"
                        (click)="addToCart(product)">
                        Add to Order
                        <i class="material-icons" data-icon="add_shopping_cart"></i>
                    </button>  
                </ng-container>  
                <ng-container *ngIf="featureTags && !featureTags['ftags_membership']">
                    <button mat-raised-button id="addToCartFullbtn" class="btn-addtocart" *ngIf="!!product['product']['stock_info'] && (product['product']['stock_info']['restrict_orders'] == 0 || (product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']!=0))"
                        (click)="addToCart(product)">
                        Add to Order
                        <i class="material-icons" data-icon="add_shopping_cart"></i>
                    </button>
                </ng-container>            
            </div>     
        </ng-container>
    </div>
</div> 
